interface PageHeroProps {
  label: string;
  title: string;
  subtitle?: string;
}

export default function PageHero({ label, title, subtitle }: PageHeroProps) {
  return (
    <div className="relative pt-32 pb-16 bg-gradient-to-br from-white via-sky-50 to-white overflow-hidden">
      {/* Kasumisou right side - blended */}
      <div
        className="absolute pointer-events-none"
        style={{
          top: 0,
          right: 0,
          width: '45%',
          height: '100%',
          maskImage: 'linear-gradient(to left, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.5) 35%, rgba(255,255,255,0.1) 70%, transparent 100%)',
          WebkitMaskImage: 'linear-gradient(to left, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.5) 35%, rgba(255,255,255,0.1) 70%, transparent 100%)',
        }}
      >
        <img
          src="https://readdy.ai/api/search-image?query=gypsophila%20baby%20breath%20white%20flowers%20bouquet%20horizontal%20arrangement%20elegant%20soft%20pastel%20white%20background%20airy%20delicate%20minimal%20botanical%20photography&width=700&height=300&seq=hero_fl_r&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
          style={{ mixBlendMode: 'multiply' }}
        />
      </div>

      {/* Kasumisou left side - blended */}
      <div
        className="absolute pointer-events-none"
        style={{
          bottom: 0,
          left: 0,
          width: '30%',
          height: '80%',
          maskImage: 'linear-gradient(to right, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.2) 50%, transparent 100%)',
          WebkitMaskImage: 'linear-gradient(to right, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.2) 50%, transparent 100%)',
        }}
      >
        <img
          src="https://readdy.ai/api/search-image?query=gypsophila%20baby%20breath%20white%20flowers%20soft%20cloud%20airy%20delicate%20white%20background%20minimal%20botanical%20close%20up%20macro%20photography&width=450&height=250&seq=hero_fl_l&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-bottom"
          style={{ mixBlendMode: 'multiply' }}
        />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        <span className="text-sky-400 text-xs font-medium tracking-widest uppercase">{label}</span>
        <h1 className="text-3xl md:text-4xl font-light text-slate-800 mt-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
          {title}
        </h1>
        {subtitle && (
          <p className="text-slate-500 text-sm mt-4 max-w-md mx-auto">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
